import React from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../components/Sidebar/Sidebar';
import PageHeader from '../../components/PageHeader/PageHeader';
import Metrics from '../../components/Metrics/Metrics';
import NotificationBell from '../../components/NotificationBell/NotificationBell';
import SystemAdminBadge from '../../components/SystemAdminBadge/SystemAdminBadge';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import { useCurrentUserPermissions } from '../../hooks/useCurrentUserPermissions';
import styles from './MetricsPage.module.scss';

const MetricsPage: React.FC = () => {
  const { isSystemAdmin } = useCurrentUserPermissions();
  const { t } = useTranslation('templates');

  return (
    <div className={styles.pageLayout}>
      <Sidebar />
      <div className={styles.pageContent}>
        <PageHeader title={t('metrics.title')} subtitle={t('metrics.description')}>
          <LanguageSwitcher />
          {isSystemAdmin ? <SystemAdminBadge /> : <NotificationBell />}
        </PageHeader>
        <Metrics />
      </div>
    </div>
  );
};

export default MetricsPage;
